import React, {Component} from 'react'
import fire from '../../../../database/firebase'
import styled from 'styled-components'
import ClipLoader from "react-spinners/ClipLoader";

const Styles = styled.div `

`

export default class LoginComponentSm extends Component {
    constructor() {
        super()
        this.state = {
            showLoginPage: true,
            signUpHeader: "Psst... we finally have a loyalty program!",
            signUpSubheader: "Login",

            // - - LOGIN INPUT FIELDS - - //

            loginEmail: "",
            loginEmailBorderColor: "#ABA9A9",
            loginEmailTextColor: "#ABA9A9",

            loginPassword: "",
            loginPasswordBorderColor: "#ABA9A9",
            loginPasswordTextColor: "#ABA9A9",

        }
        this.loginEmailInputRef = React.createRef();
        this.loginPasswordInputRef = React.createRef();
    }

            //? - - LOGIN INPUT FUNCTIONS - - ?//

    handleLoginEmailClicked = () => {
        if (this.loginEmailInputRef.current) {
            this.loginEmailInputRef.current.focus();
        }
        this.setState({
            loginEmailBorderColor: "#321d05",
            loginEmailTextColor: "#321d05"
        })

        if (this.state.loginPassword == "") {
            this.setState({
                loginPasswordBorderColor: "#ABA9A9",
                loginPasswordTextColor: "#ABA9A9"
            })
        }
    }
        
    handleLoginPasswordClicked = () => {
        this.loginPasswordInputRef.current.focus();
        this.setState({
            loginPasswordBorderColor: "#321d05",
            loginPasswordTextColor: "#321d05"
        })

        if (this.state.loginEmail == "") {
            this.setState({
                loginEmailBorderColor: "#ABA9A9",
                loginEmailTextColor: "#ABA9A9"
            })
        }
    }

    loginBtnClicked = () => {
        if (this.state.loginEmail == "") {
            this.handleScrollToTopOfSignUpForm()
            this.setState({
                loginEmailBorderColor: "red"
            })
        } else {
            this.setState({
                loginEmailBorderColor: "#321d05"
            })
        }

        if (this.state.loginPassword == "") {
            this.handleScrollToTopOfSignUpForm()
            this.setState({
                loginPasswordBorderColor: "red"
            })
        } else {
            this.setState({
                loginPasswordBorderColor: "#321d05"
            })
        }

        if (this.state.loginEmail != "" && this.state.loginPassword != "") {
            this.setState({
                loginEmailBorderColor: "#321d05",
                loginPasswordBorderColor: "#321d05"
            })
                this.setState({
                    showLoginPage: false,
                    showSignUpPageLoading: true,
                }, () => {
                    setTimeout(() => {
                        fire.auth().signInWithEmailAndPassword(this.state.loginEmail.toLowerCase(), this.state.loginPassword)
                        .then((user) => {
                            window.location.href = `/home/${this.props.dataSentFromParent}`
                        })
                        .catch((error) => {
                            if (error.message.includes("INVALID_LOGIN_CREDENTIALS")) {
                                this.setState({
                                    showSignUpPageLoading: false,
                                    showLoginPage: true,
                                    showLoginErrorMsg: true,
                                    loginErrorMsg: "Login information is incorrect"
                                })
                            } else if (error.message.includes("The email address is badly formatted")) {
                                this.setState({
                                    showSignUpPageLoading: false,
                                    showLoginPage: true,
                                    showLoginErrorMsg: true,
                                    loginErrorMsg: "Email format is incorrect"
                                })
                            } else if (error.message.includes("network error")) {
                                this.setState({
                                    showSignUpPageLoading: false,
                                    showLoginPage: true,
                                    showLoginErrorMsg: true,
                                    loginErrorMsg: "Network connection interrupted"
                                })
                            }
                        })
                    }, 3000)
                })
            
        }
    }

    handleChange = (event) => {
        this.setState({
            [event.target.id] : event.target.value,
        })
    }

    handleScrollToTopOfSignUpForm = () => {
        const element = document.getElementById('topOfSignUpForm');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
    }

    redirectToSignUpPage = () => {
        window.location.href = `/sign-up/${this.props.dataSentFromParent}`
    }

    render () {

                //* - - LOGIN STYLES - - *//

            // Email

            let loginEmailInput = {
                border: `2px solid ${this.state.loginEmailBorderColor}`
            }
    
            let loginEmailLabel = {
                color: this.state.loginEmailTextColor
            }
    
                // Password
    
            let loginPasswordInput = {
                border: `2px solid ${this.state.loginPasswordBorderColor}`
            }
    
            let loginPasswordLabel = {
                color: this.state.loginPasswordTextColor
            }


        return (
            <Styles>
                {this.state.showLoginPage && 
                    <div className='signUpPage'>
                        <div className='registrationHeader'>
                            <h1>{this.state.signUpHeader}</h1>
                            <h2 id='topOfSignUpForm'>{this.state.signUpSubheader}</h2>
                            {this.state.showLoginErrorMsg && 
                                <p className='loginErrMsg'>{this.state.loginErrorMsg}</p>
                            }
                        </div>
                        <div className='inputStyle'>
                            <div className='inputBox' onClick={this.handleLoginEmailClicked} style={loginEmailInput}>
                                <h5 style={loginEmailLabel}>Email</h5>
                                <input
                                id='loginEmail'
                                type='email'
                                placeholder='Enter your email'
                                value={this.state.loginEmail}
                                onChange={this.handleChange}
                                onClick={this.handleFirstNameClicked}
                                ref={this.loginEmailInputRef}
                                />
                            </div>
                        </div>
                        <div className='inputStyle'>
                            <div className='inputBox' onClick={this.handleLoginPasswordClicked} style={loginPasswordInput}>
                                <h5 style={loginPasswordLabel}>Password</h5>
                                <input
                                id='loginPassword'
                                type='password'
                                placeholder='Enter your password'
                                value={this.state.loginPassword}
                                onChange={this.handleChange}
                                onClick={this.handleLoginPasswordClicked}
                                ref={this.loginPasswordInputRef}
                                />
                            </div>
                        </div>
                        <div className='signUpBtn'>
                            <button
                            onClick={this.loginBtnClicked}
                            >Login</button>
                        </div>
                        <div className='loginAlternative'>
                            <div className='loginSeparator'>
                                <div className='loginSeparatorCol1'>
                                    <div className='theSeparatorLine'></div>
                                </div>
                                <div className='loginSeparatorCol2'>
                                    <p>OR</p>
                                </div>
                                <div className='loginSeparatorCol3'>
                                    <div className='theSeparatorLine'></div>
                                </div>
                            </div>
                            <div className='signUpBtn'>
                                <button
                                onClick={this.redirectToSignUpPage}
                                >Sign Up</button>
                            </div>
                        </div>
                        <div className='footer'>
                            <p>© 2023</p>
                        </div>
                    </div>
                }
                {this.state.showSignUpPageLoading && 
                    <div className='signUpPageLoading'>
                        <ClipLoader
                        color="#321d05"
                        loading={true}
                        // cssOverride={override}
                        size={40}
                        aria-label="Loading Spinner"
                        data-testid="loader"
                        />
                        <p>{this.state.loadingMessage}</p>
                    </div>
                }
            </Styles>
        )
    }
}